const serverAddress = `https://shortify-cut-default-rtdb.europe-west1.firebasedatabase.app/`

export default serverAddress